import { Admin                          }  from '../../dataTypes/adminManagment/types'
import { getAdminInfosByEmail           }  from '../../backendServices/adminManagment/api'

import { ActionType                     ,
         actionInitAuthentication       ,
		 actionSetLogin                 ,
         actionSetToken                 ,
         actionSetAdmin                 ,
		 actionCountAttempt             ,
         DispatchTypeInitAuthentication ,
         DispatchTypeSetLogin           ,
         DispatchTypeSetToken           ,
         DispatchTypeSetAdmin           ,
		 DispatchTypeCountAttempt       }  from './types';

export const initAuthentication = (complete: boolean) => 
 {
  const action: actionInitAuthentication = 
   {
    type:     ActionType.INIT_AUTHENTICATION,
	complete: complete
   }

  return ( dispatch: DispatchTypeInitAuthentication ) => 
   {
    dispatch (action);
   }
 } 

export const setLogin = ( login: string ) => 
 {
  const action: actionSetLogin = 
   {
    type:  ActionType.SET_LOGIN,
	login: login
   }

  return ( dispatch: DispatchTypeSetLogin ) => 
   {
    dispatch (action);
   }
 } 

export const setToken = ( token: string ) => 
 {
  const action: actionSetToken =
   {
    type:  ActionType.SET_TOKEN,
	token: token
   }
 
  return ( dispatch: DispatchTypeSetToken ) => 
   {
    dispatch (action);
   }
 }
 
export const setAdmin = ( admin: Admin ) =>
 {
  const action: actionSetAdmin =
   {
    type:  ActionType.SET_ADMIN,
	admin: admin
   }

  return ( dispatch: DispatchTypeSetAdmin ) =>
   {
    dispatch (action);
   }
 }

/**
 * Recharge la fiche admin depuis le backend et la réinjecte dans le store.
 *
 * Les compteurs de quota (nbChannelsUsed, nbDevicesUsed, quotaUsed) sont modifiés
 * côté serveur par des opérations que le front ne peut pas comptabiliser lui-même :
 * l'activation/désactivation d'une chaîne libère ou consomme un slot de chaîne et
 * relâche les devices de la régie de cette chaîne. Sans ce rechargement, l'affichage
 * du header resterait figé sur les valeurs du login jusqu'à la reconnexion suivante.
 *
 * À appeler après une opération qui touche ces compteurs, jamais en boucle : la
 * lecture backend embarque une géolocalisation de la dernière connexion.
 */
export const refreshAdmin = ( email: string ) =>
 {
  return async ( dispatch: DispatchTypeSetAdmin ) =>
   {
    if ( email === '' ) { return; }

    const result = await getAdminInfosByEmail ( email );

    if ( result.code === 1 )
     {
      const action: actionSetAdmin =
       {
        type:  ActionType.SET_ADMIN,
        admin: result.payload
       }

      dispatch (action);
     }
   }
 }

export const countAttempt = () =>
 {
  const action: actionCountAttempt =
   {
    type:  ActionType.COUNT_ATTEMPT
   }
 
  return ( dispatch: DispatchTypeCountAttempt ) => 
   {
    dispatch (action);
   }
 }
  
